module.exports = __webpack_public_path__ + "static/media/contact-bg-3.be3bf3a4.jpg";